import React, { Component } from 'react';
import css from './Header.module.css';
import logo from "./../Images/abacus_logo.png";
import ThreeDRotation from '@material-ui/icons/ExitToApp';
import {SSOLogoutUrl} from "./../Config";

class Header extends Component {
  exitClick(){
    window.location.replace(SSOLogoutUrl);
  }

  render() {
    return (
      <div className={css.header}>
          <div className={css.section_image}><img alt="Logo" className={css.logo} src={logo}></img></div>
          <div className={css.section_text}><label className={css.label_monitor}>AbacusNext Monitor</label></div>
          {this.props.isShowExit?<div className={css.exit_div}><ThreeDRotation onClick={this.exitClick.bind(this)} className={css.icon_exit} /></div>:null}
      </div>
    );
  }
}

export default Header;